import { IconCancel, IconDuplicate, IconEdit, IconTrash } from 'assets/img';
import { DeleteButton, PrimaryButton, useDialog } from 'ogp/providers/dialog-provider';
import { ContextMenuItem } from 'redesign';
import { useAlert } from 'shared/components/alerts';

import { useHqArchiveShift } from 'shared/components/shift-detail-modal/query-hooks/hq/use-hq-archive-shift';
import { ShiftDetail } from 'api/services/shift/schema/shift-detail.schema';

export type ShiftActionCallback = (action: 'edit' | 'duplicate', shiftId: string) => void;

type Props = {
  data?: ShiftDetail;
  closeModal: () => void;
  onDelete: () => void;
  setShiftAction: ShiftActionCallback;
};

const useGetShiftDetailHeadActions = ({ data, closeModal, onDelete, setShiftAction }: Props) => {
  const { alertSuccess, alertError } = useAlert();
  const { openDialog, closeDialog, disableDialog, enableDialog } = useDialog();

  const { mutate, isLoading: isArchiving } = useHqArchiveShift(data?.id, {
    onSuccess: () => {
      onDelete();
      alertSuccess('De shift is succesvol verwijderd');
      closeDialog();
      closeModal();
    },
    onError: (e) => alertError(e),
    onSettled: () => {
      enableDialog();
    },
  });
  const handleDelete = () => {
    openDialog(
      {
        title: 'Shift verwijderen',
        content:
          'Weet je zeker dat je de shift wilt verwijderen? Dit kan alleen als er geen geaccepteerde shiftclaims zijn.',
        secondaryButton: (props) => (
          <PrimaryButton startIcon={<IconCancel />} {...props} iconColorMode="fill">
            Annuleer
          </PrimaryButton>
        ),
        primaryButton: (props) => <DeleteButton {...props} />,
      },
      () => {
        disableDialog();
        mutate();
      }
    );
  };

  const handleEdit = () => {
    if (!data) {
      return;
    }
    closeModal();
    setShiftAction('edit', data.id);
  };

  const handleDuplicate = () => {
    if (!data) {
      return;
    }
    closeModal();
    setShiftAction('duplicate', data.id);
  };

  const isMultiDayShift = data?.isMultiDayShift === true;

  const children = [
    ...(isMultiDayShift
      ? []
      : [
          <ContextMenuItem key="edit" onClick={handleEdit}>
            <IconEdit />
            Wijzig
          </ContextMenuItem>,
          <ContextMenuItem key="duplicate" onClick={handleDuplicate}>
            <IconDuplicate />
            Dupliceer
          </ContextMenuItem>,
        ]),
    <ContextMenuItem key="delete" onClick={handleDelete}>
      <IconTrash />
      Verwijderen
    </ContextMenuItem>,
  ];

  return { children, isArchiving };
};

export { useGetShiftDetailHeadActions };
